module.exports = __webpack_public_path__ + "img/logo_img.83fa2e0c.png";